import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useFormat } from "./format";
import { useTRPC } from "./trpc";

/**
 * "incl. tax" or "excl. tax": the garage's price basis (Settings › General). Prices are stored
 * without tax and the server shows them on this basis (ADR 0009). With a rate, or "today" for the
 * one valid today, the label names it: "incl. 19 % tax".
 */
export function usePriceBasis(taxRateBp?: number | "today"): string {
  const { t } = useTranslation();
  const format = useFormat();
  const trpc = useTRPC();
  const { data: settings } = useQuery(trpc.settings.get.queryOptions());
  if (settings?.pricesIncludeTax === false) return t("prices.exclTax");
  const rate = taxRateBp === "today" ? settings?.taxRateToday : taxRateBp;
  return rate === undefined
    ? t("prices.inclTax")
    : t("prices.inclTaxRate", { rate: format.taxRate(rate) });
}
